<template>
  <div>
    <v-card class="mx-auto my-5" max-width="800" outlined>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text>
        <!-- <v-select
          v-model="selectedDays"
          :items="daysOptions"
          label="انتخاب بازه زمانی"
          outlined
          dense
          class="mb-5"
          @change="fetchData"
        ></v-select> -->
        <div v-if="chartData" class="chart-container">
          <line-chart :chart-data="chartData" />
        </div>
        <div v-else class="text-center">در حال بارگذاری...</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { Line } from "vue-chartjs";

export default {
  components: {
    LineChart: {
      extends: Line,
      props: ["chartData"],
      mounted() {
        this.renderChart(this.chartData, { responsive: true, maintainAspectRatio: false });
      },
    },
  },
  props: ['title', 'subtitle', 'url'],
  data() {
    return {
      selectedDays: 30, // Default time range
      daysOptions: [30, 90, 180, 360], // Time range options
      chartData: null, // Chart data
    };
  },
  methods: {
    fetchData() {
      this.request({
        url: this.endpoint(this.url),
        params: {
          days: this.selectedDays, // Time range parameter
        },
        success: (data) => {
          const labels = data.map((item) => item.date);
          const dataset = data.map((item) => item.count);

          this.chartData = {
            labels,
            datasets: [
              {
                label: `رکورد های (${this.selectedDays} روز اخیر)`,
                data: dataset,
                borderColor: "#42A5F5",
                fill: false,
              },
            ],
          };
        },
        error: (err) => {
          console.error("Error fetching chart data:", err);
        },
      });
    },
  },
  mounted() {
    this.fetchData(); // Fetch data on mount
  },
};
</script>

<style scoped>
.chart-container {
  height: 400px;
  position: relative;
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #777;
}
</style>
